module.exports = __webpack_public_path__ + "img/8.dab65e2a.jpg";